<script>
export default {
  name: "howItWorksContent",
  data() {
    return {};
  },
  beforeUpdate() {
    document.title = "UNIFI Property: How It Works";
  },
  methods: {}
};
</script>

<template>
  <el-row class="main-wrapper">
    <el-col :span="24" class="main-banner-img-wrapper">
        <img class="main-banner-img" src="../../assets/how-it-work-banner.png" alt="img">
    </el-col>
    <el-col :span="24">
      <el-row>
        <el-col :span="24" class="main-paragraph-wrapper">
          <span class="main-paragraph">Welcome to UNIFI Property, the new destination for searching and exploring tomorrow’s Real Estate, featuring apartments, townhouses,
            house and land, land with newly completed and under construction homes. Starting your journey of purchasing a brand-new property can be
            daunting, and we are here to give you all the information you need to make an informed decision.</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="main-paragraph">Our decades long experience means we know that development properties are different to established homes. We built UNIFI Property to
            redefine how these properties are presented to you, the buyer. Because detail matters, every listing has comprehensive data on each
            individual home including:</span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col  :span="20" :offset="2" class="inclusion-img-wrapper">
          <img class="inclusion-img" src="../../assets/how-it-work-inclusion-img.jpg" alt="img">
        </el-col>
        <el-col :span="22" :offset="1" class="inclusion-description-wrapper">
          <p class="sub-paragraph">Each property includes individual floor plans and development site plans, providing a detailed overview of the layout and location. It
            also features a comprehensive price list showing the price, details, and availability of each individual home. Buyers can access
            specification guides and brochures to understand the features and finishes of the properties. Additionally, a rental appraisal is included
            to offer insights into potential rental returns. A full summary of all associated fees is provided, covering stamp duty, transfer costs,
            council rates, and strata fees, ensuring complete transparency
          </p>
        </el-col>

      </el-row>
      <el-row>
        <el-col :span="24" class="steps-section-paragraph-wrapper">
          <span class="main-paragraph">If you find a home you love, you can contact the agent directly from the listing or use our unique <strong>RESERVATION</strong> feature.  This allows you to
            reserve your property completely online in a few easy steps.  Holding your selected property for an exclusive 7-day period to kickstart the
            purchasing process with the Agent and take your property off the market.</span>
        </el-col>
      </el-row>
<!--      Steps section-->
      <el-row class="steps-section">
        <!-- Left Column - Image -->
        <el-col :xs="24" :sm="24" :md="14" :lg="14">
          <div class="steps-section-img-container">
            <img
                src="../../assets/how-it-work-steps-img.jpeg"
                alt="how it work steps image"
                class="steps-section-img"
            >
          </div>
        </el-col>

        <!-- Right Column - Features -->
        <el-col class="steps-section-column" :xs="24" :sm="24" :md="14" :lg="10">
          <h2 class="steps-title">STEPS:</h2>
          <ol class="steps-list">
            <li class="steps-list-item">
              <span class="steps-list-item-text">&#49;. Complete the online form with all details of the purchaser and conveyancer or solicitor.</span>
            </li>
            <li class="steps-list-item">
              <span class="steps-list-item-text">&#50;. Click “Pay and Submit Reservation” to pay the $1,000 reservation fee securely online.</span>
            </li>
            <li class="steps-list-item">
              <span class="steps-list-item-text">&#51;. Once your reservation is received, the Agent will
                contact you directly to prepare the contract of sale and take you through next steps.</span>
            </li>
            <li class="steps-list-item">
              <span class="steps-list-item-text">&#52;. Upon the expiry of the 7-day reservation period, your
                $1,000 reservation fee will be refunded via your original method of payment</span>
            </li>
          </ol>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" class="steps-section-paragraph-wrapper">
          <span class="main-paragraph">Start fresh in a brand-new home, that you can potentially customise to your preferences and take advantage of government incentives. Stop
            searching through properties that don’t meet your needs or spending your weekends at open inspections and search UNIFI Property for your
            real estate needs.</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="main-paragraph">There are a range of benefits of selecting a brand new or development property rather than an established home, such as;</span>
        </el-col>
      </el-row>

      <el-row class="benefits-section">

        <!-- Left Column - Benefits -->
        <el-col class="benefit-section-column" :xs="24" :sm="24" :md="14" :lg="10">
          <ul class="benefit-list">
            <li class="benefit-list-item">
              <span class="benefit-list-item-text">&#x2022; Modern amenities and features</span>
            </li>
            <li class="benefit-list-item">
              <span class="benefit-list-item-text">&#x2022; Ability to customise finishes, materials and layouts to suit your preferences</span>
            </li>
            <li class="benefit-list-item">
              <span class="benefit-list-item-text">&#x2022; Reduced maintenance and repair costs</span>
            </li>
            <li class="benefit-list-item">
              <span class="benefit-list-item-text">&#x2022; Energy efficient appliances</span>
            </li>
            <li class="benefit-list-item">
              <span class="benefit-list-item-text">&#x2022; Potential to take advantage of government incentives and stamp duty relief</span>
            </li>
            <li class="benefit-list-item">
              <span class="benefit-list-item-text">&#x2022; Lifestyle and community advantages</span>
            </li>
          </ul>
        </el-col>
        <!-- Right Column - Image -->
        <el-col :xs="24" :sm="24" :md="14" :lg="14">
          <div class="benefit-section-img-container">
            <img
                src="../../assets/how-it-work-new-property.png"
                alt="Property feature image"
                class="benefit-section-img"
            >
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="main-paragraph">At UNIFI Property, we are committed to simplifying your journey to owning a brand-new home by providing unparalleled detail, transparency, and convenience—empowering you to make confident, informed decisions about your future in a modern, thoughtfully designed property.</span>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<style scoped>
.main-wrapper{
  padding: 20px 50px;
  background-color: #ffffff;
  color: #003333;
}
.main-banner-img-wrapper{
  padding: 20px 0;
}
.main-paragraph-wrapper{
  padding: 20px 0;
}
.inclusion-description-wrapper{
  padding: 20px 0;
}
.steps-section-paragraph-wrapper{
  padding: 20px 0;
}
.main-paragraph {
  padding:  20px 0;
  color: #003333;
  font-size: 22px;
  line-height: 30px;
}
.sub-paragraph {
  padding:  10px;
  color: #003333;
  font-size: 18px;
  line-height: 25px;
  text-align: left;
}
.main-banner-img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.inclusion-img-wrapper{
  padding: 10px 0;

}
.inclusion-img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.steps-section{

}
.steps-section-img-container{
  max-width: 90%;
}
.steps-section-img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.steps-title{
  padding: 10px 0;
  font-size: 18px;
  font-weight: 600;
}
.steps-list{
  padding: 10px 0;
  font-size: 18px;
}
.steps-list-item{
  padding: 10px 0;
  font-weight: 600;

}
.benefits-section{
  padding: 10px 0;
  color: #003333;
}
.benefit-section-img-container{}
.benefit-section-img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.benefit-list{
  padding: 10px;
}
.benefit-list-item{

  margin-bottom: 10px;
  line-height: 1.6;
  font-size: 18px;

}
.benefit-list-item-text{
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/howItWorks/howItWorksContent.vue